import Select from "react-select";

// import setLandschapAndPartijen from "../../../noncomponents/setLandschapAndPartijen"

function BetrokkenPartijen({ data, chainSelection, connectionChains,
  partijenOptions, setPartijenOptions }) {

  // const [nieuwePartijenOptions, _] = setLandschapAndPartijen(data, connectionChains,
  //   chainSelection, [], setPartijenOptions, false);

  function handleChange(selection){
    const value = selection.target.value;

    if(!selection.target.checked){
      setPartijenOptions(partijenOptions.filter(partij => partij !== value));
    }else{
      setPartijenOptions([...partijenOptions, value]);
    }
  }

  const allePartijen = ['RWS', 'Waterschap', 'Provincie', 'Privaat', 'Drinkwaterbedrijf', 'Gemeente'];

  return (
    <div className="BetrokkenPartijen">
      <label>{'Betrokken partijen '}</label>
      <ul class="ks-cboxtags">
        {allePartijen.map((partij,i) => {
          const checked = partijenOptions.includes(partij);
          const ksSelected = (i === 0) ? 'ks-selected' : ''
          return (
            <li class={ksSelected}>
              <input type="checkbox" id={partij+i} value={partij} checked={checked} onChange={handleChange}/>
              <label for={partij+i}>{partij}</label>
            </li>
          )
        })}

    </ul>
    </div>
  );
}

export default BetrokkenPartijen;
